import { FCX } from "@datassential/platform-ui-lib";
import { SelectSingle } from "@components/Select";
import { Dispatch, SetStateAction, useMemo } from "react";
import { HomeShow } from "@core/constants";
import { useHomeSearchSettingsContext } from "@pages/Home/HomeContext";

const SelectShow: FCX<{
    show: HomeShow;
    setShow: Dispatch<SetStateAction<HomeShow>>;
    availableOptions?: HomeShow[];
    disabled?: boolean;
}> = ({
    show,
    setShow,
    disabled = false,
    availableOptions = [HomeShow.Raw, HomeShow.Norm, HomeShow.Index],
}) => {
    const { resetSearch } = useHomeSearchSettingsContext();

    const viewOptions = useMemo(
        () => {
            return [HomeShow.Raw, HomeShow.Norm, HomeShow.Index]
                .filter(i => availableOptions.includes(i))
                .map((i) => ({
                    id: i,
                    title: i,
                }));
        },
        [availableOptions]
    );

    return (
        <SelectSingle
            disabled={disabled}
            value={show}
            setValue={setShow as () => void}
            options={viewOptions}
            label="SHOW:"
            testId="selectSearchHeaderViewAs"
            onChange={resetSearch}
        />
    );
}

export default SelectShow;